<template>
  <v-dialog :value="dialog" persistent max-width="400">
    <v-card>
      <v-card-title class="text-h5"> Create Prompt </v-card-title>

      <div class="px-5 my-5">
        <v-text-field
          label="Prompt Name"
          placeholder="Prompt Name"
          outlined
          v-model="promtName"
        ></v-text-field>
        <v-select
          outlined
          label="AI Model"
          :items="models"
          v-model="selectedModel"
          item-text="label"
          item-value="value"
          @change="setModel"
        ></v-select>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')"> Cancel </v-btn>
        <v-btn color="blue darken-1" text @click="addPrompt"> Create </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { availableAIModels, defaultModel } from '@/util/availableAIModels';

const { mapActions: promtsActions } = createNamespacedHelpers('promts');

export default {
  name: 'CreatePromts',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      models: availableAIModels,
      selectedModel: defaultModel,
      promtName: '',
    };
  },
  methods: {
    ...promtsActions(['createPromt']),
    setModel(model) {
      this.selectedModel = model;
    },
    addPrompt() {
      this.createPromt({
        name: this.promtName,
        model: this.selectedModel.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './create-promt';
</style>
